import { CountdownUntilLaunch } from "@components";

export default {
  name: "ComingSoon",
  components: {
    CountdownUntilLaunch
  }
}
